import React from 'react';
import { Instagram, Youtube, Facebook, Link as LinkIcon, Music } from 'lucide-react';
export function SocialMediaSection() {
  const socials = [{
    name: 'Instagram',
    url: 'https://www.instagram.com/netaneltoursvip/',
    icon: Instagram,
    label: '@netaneltoursvip'
  }, {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@netaneltoursvip',
    icon: Music,
    label: '@netaneltoursvip'
  }, {
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UCn3ITLWTCijIQtKYmavQqbQ',
    icon: Youtube,
    label: 'Netanel Tours VIP'
  }, {
    name: 'Facebook',
    url: 'https://www.facebook.com/Netaneltoursvip/',
    icon: Facebook,
    label: 'Netanel Tours VIP'
  }, {
    name: 'Linktree',
    url: 'https://linktr.ee/netaneltoursvip',
    icon: LinkIcon,
    label: 'All Links'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#f5f5f7]" data-id="element-163">
      <div className="max-w-7xl mx-auto text-center" data-id="element-164">
        <h2 className="text-2xl font-bold text-[#1f2933] mb-12" data-id="element-165">
          Connect With Us
        </h2>

        <div className="flex flex-wrap justify-center gap-8 md:gap-16" data-id="element-166">
          {socials.map((social, index) => <a key={index} href={social.url} target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center" data-id="element-167">
              <div className="w-16 h-16 rounded-full border border-gray-300 bg-white flex items-center justify-center mb-4 group-hover:border-[#4b5563] group-hover:bg-gray-50 transition-all duration-300" data-id="element-168">
                <social.icon className="h-8 w-8 text-[#1f2933] group-hover:text-[#4b5563] transition-colors" data-id="element-169" />
              </div>
              <span className="text-sm font-medium text-gray-500 group-hover:text-[#1f2933] transition-colors" data-id="element-170">
                {social.name}
              </span>
              <span className="text-xs text-gray-400 mt-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-171">
                {social.label}
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}